/* eslint-disable */
import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import DeleteIcon from "@mui/icons-material/Delete";

//Custom components
import DialogToolbarMenuItem from "@/ui/Dialog/DialogToolbarMenuItem";

//Types
import { IDialogToolbarMenuItemDetail } from "@/@types/ui/Dialog";

const DialogToolbarMenuItemDelete = React.forwardRef<HTMLLIElement, IDialogToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();

  return <DialogToolbarMenuItem label={t("buttons.delete")} icon={<DeleteIcon />} {...props} ref={ref} />;
});

export default DialogToolbarMenuItemDelete;
